module.exports = __webpack_public_path__ + "static/media/Coach_Cabin_Module_New.ab89f303.jpg";